import React,{Component} from 'react';
import {Line} from 'react-chartjs-2';
import { Button } from 'react-bootstrap';
import './Body.css';

class CurveLineChart extends Component
{
  
  constructor() {
    super();
    this.state = {
      lineChartData: []
    }
    this.data0 = this.data0.bind(this);
    this.data1 = this.data1.bind(this);
    this.data2 = this.data2.bind(this);
  }


      
  
  componentDidMount() {
    if(this.props.data.year){

      this.data0();
    }
    console.log(this.props)
    }


    data0(){
      this.setState({
        lineChartData:{
          labels: this.props.data.year,
          datasets: [
          {
            label: 'All Time',
            data: this.props.data.data,
            borderColor:  ['rgba(54,162,235,0.2)'],
            borderWidth: 5,        
            pointBorderColor: 'rgba(54,162,235,0.8)',
            pointBackgroundColor: 'rgba(54,162,235,0.8)',
            pointHoverBackgroundColor: '#5AC53B',
            pointHoverBorderColor: '#f0f0f0',
            pointHoverBorderWidth: 4,
            pointHoverRadius: 6,
            fill: false,
            tension: 0.4
          }
        ]
      }
     })
    }
   
   data1(){
    this.setState({
      lineChartData:{
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
          {
            label: 'This Year',
            data: [49, 22, 23,65,43,21,56,57,100,23,43,21],
            borderColor:  ['rgba(162,54,235,0.2)'],
            borderWidth: 5,            
            pointBorderColor: 'rgba(162,54,235,0.2)',
            pointBackgroundColor: 'rgba(162,54,235,0.2)',
            pointHoverBackgroundColor: '#5AC53B',
            pointHoverBorderColor: '#f0f0f0',
            pointHoverBorderWidth: 4,
            pointHoverRadius: 6,
            fill: false,
            tension: 0.4
          }
        ],

      }
    })
  }


    data2(){
      this.setState({
        lineChartData:{
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [
            {
              label: 'This Week',
              data: [49, 22, 23,65,43,21,35],
              borderColor:  ['rgba(255, 162, 54, 0.2)'],
              borderWidth: 5,            
              pointBorderColor: 'rgba(255, 162, 54, 0.2)',
              pointBackgroundColor: 'rgba(255, 162, 54, 0.2)',
              pointHoverBackgroundColor: '#5AC53B',
              pointHoverBorderColor: '#f0f0f0',
              pointHoverBorderWidth: 4,
              pointHoverRadius: 6,
              fill: false,
              tension: 0.4
            }
          ]
        }
      })
    }



  render() {
    const options={
        plugins: {
            legend: {
                display: false
            }
        },
        responsive: true,
        maintainAspectRatio: true,
        
        scales:{
            xAxes: { 
              ticks:{
                    color: 'black'
                },
               grid: {
                display: false
               }
            },
            yAxes:{
                ticks:{
                    beginAtZero: true,
                    color: 'black'
                }, 
                grid: {
                    display: false,
               drawBorder: false
               }
            }
        }
      }
    return (
      <>
      <div className="btns">
          <Button onClick={this.data0} variant ="flat1" className="curvegraphbutton">All Time</Button>
          <Button onClick={this.data1} variant ="flat2" className="curvegraphbutton">This Year</Button>
          <Button onClick={this.data2} variant ="flat3" className="curvegraphbutton">This Week</Button>
         
         </div>
          <Line data={this.state.lineChartData} options={options} />
      </>
  )
  }
}

export default CurveLineChart;